import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import Login from "../pages/Login";
import AdminDashboard from "../pages/dashboard/AdminDashboard";
import ProjectDashboard from "../pages/dashboard/ProjectDashboard";
import SelectProject from "../pages/dashboard/SelectProject";
import CreateProject from "../pages/system/ProjectCreate";
import DashboardLayout from "../pages/dashboard/DashboardLayout";

import AdminRoute from "./AdminRoute";
import ProjectRoute from "./ProjectRoute";
import UserManage from "../pages/admin/UserManage";
import ProjectInfoManage from "../pages/admin/ProjectInfoManage";

import Layout from "../components/layout/Layout";

import FourDLayout from "../pages/4D/FourDLayout";
import Project4DPage from "../pages/4D/Project4DPage";
import Project4DUploadPage from "../pages/4D/Project4DUploadForm";

import OverviewView from "../pages/overview/OverviewView";
import OverviewLayout from "../pages/overview/OverviewLayout";
import OverviewRegister from "../pages/overview/OverviewRegister";
import OverviewRegisterEdit from "../pages/overview/OverviewRegisterEdit";
import OverviewOrg from "../pages/overview/OrganizationChart";

import PermitList from "../pages/permit/List";
import PermitSchedule from "../pages/permit/Schedule";
// import PermitLayout from "../pages/permit/PermitLayout";
import PermitFormPage from "../pages/permit/FormPage";
import PermitView from "../pages/permit/PermitView";

import DocsData from "../pages/docs/Data";

import ConstDaily from "../pages/const/Daily";
import ConstDailyEditor from "../pages/const/DailyEditor";
import ConstDailyView from "../pages/const/DailyView";
import ConstDailyUserDefine from "../pages/const/UserDefine";

import ConstProgress from "../pages/const/Progress";
import ConstProgressNew from "../pages/const/Progress_new";
import ConstProgressView from "../pages/const/Progress_view";
import ConstUserTemplate from "../pages/const/UserTemplate";
import ConstUserTemplate_view from "../pages/const/UserTemplate_view";
import ConstPhoto from "../pages/const/Photo";
import ConstPhotoNew from "../pages/const/Photo_new";
import ConstOrderNew from "../pages/const/Order_new";
import ConstPhotoView from "../pages/const/Photo_view";
import ConstPhotoBoard from "../pages/const/PhotoBoard";
import ConstPhotoBoardView from "../pages/const/PhotoBoard_view";
import ConstWorkDetail from "../pages/const/WorkDetailPage";

import ConstOrder from "../pages/const/Order";
import ConstOrderView from "../pages/const/Order_view";
import ConstOrderComplete from "../pages/const/OrderComplete";
// import ConstTest from "../pages/const/Test3D";
import ConstOrderCompleteNew from "../pages/const/OrderComplete_new";
import ConstOrderCompleteView from "../pages/const/OrderComplete_view";
import ConstReport from "../pages/const/Report";

import DesignRequest from "../pages/design/Request";
import DesignRequestNew from "../pages/design/Request_new";
import DesignRequestView from "../pages/design/Request_view";
import DesignDetail from "../pages/design/Detail";
import DesignLogs from "../pages/design/Logs";
import DesignFcrNew from "../pages/design/Fcr_new";
import DesignList from "../pages/design/Fcr";
import DesignFcrView from "../pages/design/Fcr_view";
import DesignFcnNew from "../pages/design/Fcn_new";
import DesignFcnView from "../pages/design/Fcn_view";
import DesignDcnNew from "../pages/design/Dcn_new";
import DesignDcnView from "../pages/design/Dcn_view";

import QualityInspectionNew from "../pages/quality/inspection/Inspection_new";
import QualityCheckListNew from "../pages/quality/inspection/CheckList_new";
import QualityNcrNew from "../pages/quality/ncr/Ncr_new";
import QualityCarNew from "../pages/quality/car/Car_new";
import QualityCreate from "../pages/quality/Create";
import QualityBoard from "../pages/quality/QualityBoard";
import QualityView from "../pages/quality/QualityView";

import SafetyBoard from "../pages/safety/SafetyBoard";
import SafetyChecklist from "../pages/safety/Checklist";
import SafetyLive from "../pages/safety/Live";
import SafetyViewRouter from "../pages/safety/SafetyView";
import SafetyCreate from "../pages/safety/Create";
import SafetyForm from "../pages/safety/Form";

import MaterialsBoard from "../pages/materials/MaterialBoard";
import MaterialsStock from "../pages/materials/Stock";
import MaterialView from "../pages/materials/MaterialView";
import MaterialsUserTemplateNew from "../pages/materials/MaterialsUserTemplateNew";
import Plan_new from "../pages/materials/plan/Plan_new";
import Order_new from "../pages/materials/order/Order_new";
import In_new from "../pages/materials/inout/In_new";
import Out_new from "../pages/materials/inout/Out_new";
import Request_new from "../pages/materials/check/Request_new";
import Confirm_new from "../pages/materials/check/Confirm_new";

import ContractInfo from "../pages/contract/Info";
import ContractInfoNew from "../pages/contract/Info_new";
import ContractInfoView from "../pages/contract/Info_view";
import ContractSub from "../pages/contract/Sub";
import ContractSubNew from "../pages/contract/Sub_new";
import ContractSubView from "../pages/contract/Sub_view";
import ContractResult from "../pages/contract/Result";
import ContractCost from "../pages/contract/Cost";
import ContractCostList from "../pages/contract/Cost_list";
import ContractCostNew from "../pages/contract/Cost_new";
import ContractCostView from "../pages/contract/Cost_view";
import ContractBill from "../pages/contract/Bill";
import ContractBillNew from "../pages/contract/Bill_new";
import ContractBillView from "../pages/contract/Bill_view";

import MeetingPlanShell from "../pages/communication/meeting/MeetingPlanShell";
import MeetingRoomManage from "../pages/communication/meeting/MeetingRoomManage";

import ScheduleCalendar from "../pages/communication/schedule/ScheduleCalendar";

import Notice from "../pages/communication/notice/Notice";
import NoticeView from "../pages/communication/notice/Notice_view";
import NoticeCreate from "../pages/communication/notice/Notice_create";

import ProcessUpload from "../pages/process/upload";
import ProcessCon from "../pages/process/Construction";
import ProcessProgress from "../pages/process/Progress";
import ProcessMta from "../pages/process/Mta";
import ProcessMilestone from "../pages/process/Milestone";

import ApprovalRequest from "../pages/approval/Request";
import ApprovalRequestEdit from "../pages/approval/Type_edit";
import ApprovalDocs from "../pages/approval/Docs";
import ApprovalDocsView from "../pages/approval/Docs_view";
import ApprovalMydocs from "../pages/approval/Mydocs";
import ApprovalTypeList from "../pages/approval/TypeList";

import FAQList from "../pages/FAQ/FAQList";

import SystemUser from "../pages/system/User";
import SystemUserAdd from "../pages/system/User_add";
import SystemUserList from "../pages/system/User_list";
import SystemUserCompany from "../pages/system/User_company";
import SystemCompanyAdd from "../pages/system/User_company_add";
import SystemUserPcp from "../pages/system/User_pcp";
import SystemUserDepartment from "../pages/system/User_department";
import SystemUserPosition from "../pages/system/User_position";
import SystemGrant from "../pages/system/Grant";
import SystemProjectModify from "../pages/system/ProjectModify";
import MyPage from "../pages/system/MyPage";

// css 확인용 페이지
import SystemStyleGuide from "../pages/system/StyleGuide";

import PcModuleProd from "../pages/pc_module/Prod";
import PcModuleMatl from "../pages/pc_module/Matl";
import PcModuleQuality from "../pages/pc_module/Quality";
import PcModuleStock from "../pages/pc_module/Stock";

import DocsLayout from "../pages/docs/DocsLayout";
import ConstLayout from "../pages/const/ConstLayout";
import DesignLayout from "../pages/design/DesignLayout";
import QualityLayout from "../pages/quality/QualityLayout";
import SafetyLayout from "../pages/safety/SafetyLayout";
import MaterialsLayout from "../pages/materials/MaterialsLayout";
import ContractLayout from "../pages/contract/ContractLayout";
import MeetingLayout from "../pages/communication/meeting/MeetingLayout";
import ProcessLayout from "../pages/process/ProcessLayout";
import ApprovalLayout from "../pages/approval/ApprovalLayout";
import SystemLayout from "../pages/system/SystemLayout";
import PcmoduleLayout from "../pages/pc_module/PcmoduleLayout";
import PermitLayout from "../pages/permit/PermitLayout";
import DelayPrediction from "../components/process/DelayPrediction";

import FormViewPrint from "../components/common/print/FormViewPrint";

// AI 페이지
import AIDashboard from "../pages/ai/AIDashboard";
import AIChat from "../pages/ai/AIChat";
import DocumentSummary from "../pages/ai/DocumentSummary";
import ComingSoon from "../pages/ai/ComingSoon";

function AppRouter() {
  return (
    <Routes>
      <Route
        path="/print/:id/:module/:doc_type/:dns"
        element={<FormViewPrint />}
      />
      <Route path="/delay" element={<DelayPrediction />} />

      <Route path="/login" element={<Login />} />

      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<UserManage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route
          path="/admin/projects/:projectId/edit"
          element={<ProjectInfoManage />}
        />
      </Route>

      {/* 헤더추가, 메뉴바 없음 */}
      <Route element={<ProjectRoute />}>
        <Route path="/create-project" element={<CreateProject />} />
        <Route path="/select-project" element={<SelectProject />} />
        <Route
          path="/project/:projectId/system/select-project/"
          element={<Navigate to="/select-project/" replace />}
        />{" "}
        {/* 시스템 관리 -> 전체 프로젝트 관리로 이동 */}
      </Route>

      {/* 헤더, 메뉴바 포함 */}
      <Route element={<Layout />}>
        <Route element={<ProjectRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/project/:id" element={<ProjectDashboard />} />
          </Route>
          <Route path="/project/:id/overview" element={<OverviewLayout />}>
            {/* <Route index element={<OverviewView />} /> */}
            <Route path="view" element={<OverviewView />} />
            <Route path="register" element={<OverviewRegister />} />
            <Route path="register/edit" element={<OverviewRegisterEdit />} />
            <Route path="org" element={<OverviewOrg />} />
          </Route>
          <Route path="/project/:id/permit" element={<PermitLayout />}>
            <Route path="list" element={<PermitList />} />
            <Route path="schedule" element={<PermitSchedule />} />
            <Route path="new" element={<PermitFormPage />} />
            <Route path="edit/:permitId" element={<PermitFormPage />} />
            <Route path="view/:permitId" element={<PermitView />} />
          </Route>

          <Route path="/project/:id/docs" element={<DocsLayout />}>
            <Route index element={<Navigate to="data" replace />} />
            <Route path="data" element={<DocsData />} />
          </Route>

          <Route path="/project/:id/const" element={<ConstLayout />}>
            {/* <Route path="test" element={<ConstTest />} /> */}
            <Route path="daily" element={<ConstDaily />} />
            <Route path="daily/new" element={<ConstDailyEditor />} />
            <Route path="daily/:dns/" element={<ConstDailyEditor />} />
            <Route path="daily/:dns/view" element={<ConstDailyView />} />
            <Route path="userDefine" element={<ConstDailyUserDefine />} />
            <Route path="progress" element={<ConstProgress />} />
            <Route path="progress/new" element={<ConstProgressNew />} />
            <Route path="progress/:dns" element={<ConstProgressNew />} />
            <Route path="progress/:dns/view" element={<ConstProgressView />} />
            <Route path="userTemplate" element={<ConstUserTemplate />} />
            <Route
              path="userTemplate/view/:templateId"
              element={<ConstUserTemplate_view />}
            />
            <Route
              path="userTemplate/new"
              element={<ConstUserTemplate_view />}
            />
            <Route path="photo" element={<ConstPhoto />} />
            <Route path="photo/new" element={<ConstPhotoNew />} />
            <Route path="photo/view/:photoId" element={<ConstPhotoView />} />
            <Route path="photoboard" element={<ConstPhotoBoard />} />
            <Route
              path="photoboard/view/:photoboardId"
              element={<ConstPhotoBoardView />}
            />
            <Route path="order" element={<ConstOrder />} />
            <Route path="order/new" element={<ConstOrderNew />} />
            <Route path="order/:dns" element={<ConstOrderNew />} />
            <Route
              path="order/:workorderId/view"
              element={<ConstOrderView />}
            />
            <Route path="ordercomplete" element={<ConstOrderComplete />} />
            <Route
              path="ordercomplete/new"
              element={<ConstOrderCompleteNew />}
            />
            <Route
              path="ordercomplete/:dns"
              element={<ConstOrderCompleteNew />}
            />
            <Route
              path="ordercomplete/:completionreportId/view"
              element={<ConstOrderCompleteView />}
            />
            <Route path="report" element={<ConstReport />} />
            <Route path="workdetails" element={<ConstWorkDetail />} />
          </Route>

          <Route path="/project/:id/design" element={<DesignLayout />}>
            <Route path="request" element={<DesignRequest />} />
            <Route path="request/new" element={<DesignRequestNew />} />
            <Route path="request/:dns" element={<DesignRequestView />} />
            <Route path="detail" element={<DesignDetail />} />
            <Route path="logs" element={<DesignLogs />} />
            <Route path="list" element={<DesignList />} />
            <Route path="list/:docType" element={<DesignList />} />
            <Route path="fcn/new" element={<DesignFcnNew />} />
            <Route path="fc/new" element={<DesignFcrNew />} />
            <Route path="dcn/new" element={<DesignDcnNew />} />
            <Route path="fcn/:dns" element={<DesignFcrNew />} />
            <Route path="fcr/:dns" element={<DesignFcrNew />} />
            <Route path="fc/:dns" element={<DesignFcrNew />} />
            <Route path="dcn/:dns" element={<DesignDcnNew />} />
            <Route path="fcr/:dns/view" element={<DesignFcrView />} />
            <Route path="fcn/:dns/view" element={<DesignFcrView />} />
            <Route path="dcn/:dns/view" element={<DesignDcnView />} />
          </Route>

          <Route path="/project/:id/quality" element={<QualityLayout />}>
            <Route path="create" element={<QualityCreate />} />
            <Route path="qualityboard" element={<QualityBoard />} />
            <Route path="list/all" element={<QualityBoard />} />
            <Route path="list/:boardType" element={<QualityBoard />} />
            <Route path="inspection/new" element={<QualityInspectionNew />} />
            <Route path="checklist/new" element={<QualityCheckListNew />} />
            <Route path="ncr/new" element={<QualityNcrNew />} />
            <Route path="car/new" element={<QualityCarNew />} />
            {/* 소문자 경로 */}
            <Route path="inspection/:dns" element={<QualityInspectionNew />} />
            <Route path="checklist/:dns" element={<QualityCheckListNew />} />
            <Route path="ncr/:dns" element={<QualityNcrNew />} />
            <Route path="car/:dns" element={<QualityCarNew />} />
            {/* 대문자 경로 (호환성) */}
            <Route path="INSPECTION/:dns" element={<QualityInspectionNew />} />
            <Route path="CHECKLIST/:dns" element={<QualityCheckListNew />} />
            <Route path="NCR/:dns" element={<QualityNcrNew />} />
            <Route path="CAR/:dns" element={<QualityCarNew />} />
            {/* doc_type 경로 (MI/PC/NC/CA) */}
            <Route path="MI/:dns" element={<QualityInspectionNew />} />
            <Route path="PC/:dns" element={<QualityCheckListNew />} />
            <Route path="NC/:dns" element={<QualityNcrNew />} />
            <Route path="CA/:dns" element={<QualityCarNew />} />
            {/* View 경로 */}
            <Route path=":context/:dns/view" element={<QualityView />} />
          </Route>

          <Route path="/project/:id/safety" element={<SafetyLayout />}>
            <Route index element={<Navigate to="board" replace />} />
            <Route path="create" element={<SafetyCreate />} />
            <Route path=":mode/new" element={<SafetyForm />} />
            <Route path="board/" element={<SafetyBoard />} />
            <Route path="board/:doc_type" element={<SafetyBoard />} />
            <Route path="calendar" element={<SafetyChecklist />} />
            <Route path="live" element={<SafetyLive />} />

            <Route
              path=":doc_type/:dns/view"
              element={<SafetyViewRouter withSidebar />}
            />
          </Route>

          <Route path="/project/:id/material" element={<MaterialsLayout />}>
            <Route index element={<Navigate to="materialboard" replace />} />
            <Route path="materialboard" element={<MaterialsBoard />} />
            <Route path="list/:formType" element={<MaterialsBoard />} />
            <Route path="stock" element={<MaterialsStock />} />
            <Route path="template/new" element={<MaterialsUserTemplateNew />} />
            <Route path=":context/:postId/view" element={<MaterialView />} />
            <Route path=":context/forms/:formId" element={<MaterialView />} />
            <Route path="plan/new" element={<Plan_new />} />
            <Route path="plan/:dns" element={<Plan_new />} />
            <Route path="order/new" element={<Order_new />} />
            <Route path="order/:dns" element={<Order_new />} />
            <Route path="gr/new" element={<In_new />} />
            <Route path="gr/:dns" element={<In_new />} />
            <Route path="gi/new" element={<Out_new />} />
            <Route path="gi/:dns" element={<Out_new />} />
            <Route path="qc/new" element={<Request_new />} />
            <Route path="qc/:dns" element={<Request_new />} />
            {/* ⭐ request는 qc의 별칭 (MaterialView에서 context로 사용) */}
            <Route path="request/:dns" element={<Request_new />} />
            <Route path="ck/new" element={<Confirm_new />} />
            <Route path="ck/:dns" element={<Confirm_new />} />
          </Route>

          <Route path="/project/:id/contract" element={<ContractLayout />}>
            <Route path="info" element={<ContractInfo />} />
            <Route path="info/new" element={<ContractInfoNew />} />
            <Route
              path="info/view/:contractId"
              element={<ContractInfoView />}
            />
            <Route path="sub" element={<ContractSub />} />
            <Route path="sub/new" element={<ContractSubNew />} />
            <Route path="sub/view" element={<ContractSubView />} />
            <Route path="result" element={<ContractResult />} />
            <Route path="cost/view" element={<ContractCost />} />
            <Route path="cost/list" element={<ContractCostList />} />
            <Route path="cost/new" element={<ContractCostNew />} />
            <Route path="cost/view" element={<ContractCostView />} />
            <Route path="bill" element={<ContractBill />} />
            <Route path="bill/new" element={<ContractBillNew />} />
            <Route path="bill/view" element={<ContractBillView />} />
          </Route>

          <Route path="/project/:id/meeting" element={<MeetingLayout />}>
            {/* 회의 관리 */}
            <Route path="plan" element={<MeetingPlanShell />} />
            <Route path="rooms" element={<MeetingRoomManage />} />
            {/* 일정 관리 */}
            <Route path="schedule" element={<ScheduleCalendar />} />
            {/* 공지 */}
            <Route path="notice/list" element={<Notice />} />
            <Route path="notice/new" element={<NoticeCreate />} />
            <Route path="notice/:noticeId/view" element={<NoticeView />} />
            <Route path=":doc_type/:dns/view" element={<MeetingPlanShell />} />
          </Route>

          <Route path="/project/:id/process" element={<ProcessLayout />}>
            <Route path="upload" element={<ProcessUpload />} />
            <Route path="construction" element={<ProcessCon />} />
            <Route path="progress" element={<ProcessProgress />} />
            <Route path="mta" element={<ProcessMta />} />
            <Route path="milestone" element={<ProcessMilestone />} />
          </Route>

          <Route path="/project/:id/approval" element={<ApprovalLayout />}>
            <Route index element={<ApprovalDocs />} />
            <Route path=":type/:dns/view" element={<ApprovalDocsView />} />
            <Route path="request/new" element={<ApprovalRequest />} />
            <Route path=":type/:dns" element={<ApprovalRequest />} />
            <Route path="mydocs" element={<ApprovalMydocs />} />
            <Route path="docs" element={<ApprovalDocs />} />
            <Route path="type" element={<ApprovalTypeList />} />
            <Route path="type/:typeId" element={<ApprovalRequestEdit />} />
          </Route>

          <Route path="/project/:id/system" element={<SystemLayout />}>
            <Route path="user" element={<SystemUser />} />
            <Route path="user/add" element={<SystemUserAdd />} />
            <Route path="user/list" element={<SystemUserList />} />
            <Route path="user/detail/:userId" element={<SystemUser />} />
            <Route path="user/company" element={<SystemUserCompany />} />
            <Route path="company/add" element={<SystemCompanyAdd />} />
            <Route path="user/pcp" element={<SystemUserPcp />} />
            <Route path="user/department" element={<SystemUserDepartment />} />
            <Route path="user/position" element={<SystemUserPosition />} />
            <Route path="grant" element={<SystemGrant />} />
            <Route path="modify" element={<SystemProjectModify />} />
            <Route path="mypage" element={<MyPage />} />
            <Route path="faq" element={<FAQList />} />

            {/* css 확인용페이지 */}
            <Route path="style-guide" element={<SystemStyleGuide />} />
          </Route>

          <Route path="/project/:id/pcmodule" element={<PcmoduleLayout />}>
            <Route path="prod" element={<PcModuleProd />} />
            <Route path="matl" element={<PcModuleMatl />} />
            <Route path="quality" element={<PcModuleQuality />} />
            <Route path="stock" element={<PcModuleStock />} />
          </Route>

          <Route path="/project/:id/4d" element={<FourDLayout />}>
            <Route index element={<Project4DPage />} />
            <Route path="upload4d" element={<Project4DUploadPage />} />
          </Route>

          {/* P6ix AI 라우트 */}
          <Route path="/project/:id/ai">
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AIDashboard />} />
            <Route path="chat" element={<AIChat />} />
            <Route path="chat/history" element={<ComingSoon title="대화 기록" description="AI 챗봇 대화 기록을 조회할 수 있는 기능입니다." />} />
            <Route path="document/summary" element={<DocumentSummary />} />
            <Route path="document/search" element={<ComingSoon title="스마트 문서 검색" description="자연어 기반 문서 검색 기능입니다." />} />
            <Route path="vision/safety" element={<ComingSoon title="안전 이미지 분석" description="시공사진에서 위험 요소를 자동으로 탐지하는 기능입니다." />} />
            <Route path="vision/quality" element={<ComingSoon title="품질 결함 탐지" description="균열, 변형 등 품질 결함을 자동으로 인식하는 기능입니다." />} />
            <Route path="predict/schedule" element={<ComingSoon title="공정 지연 예측" description="AI 기반 공정 지연 리스크 분석 기능입니다." />} />
            <Route path="predict/material" element={<ComingSoon title="자재 수요 예측" description="향후 자재 소요량을 AI로 예측하는 기능입니다." />} />
            <Route path="automation/report" element={<ComingSoon title="보고서 자동 생성" description="주간/월간 보고서를 AI가 자동으로 작성하는 기능입니다." />} />
            <Route path="automation/risk" element={<ComingSoon title="위험성 평가 AI" description="작업별 위험성을 자동으로 평가하는 기능입니다." />} />
          </Route>
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default AppRouter;
